import React from 'react';
import styled from 'styled-components';

const OffscreenRight = styled.div`
  @media screen and (min-width: 1280px) {
    max-width: calc(100vw - calc(((100vw) - calc(1280px - 3rem)) / 2));
    padding-left: 0;
    padding-right: 0;
    margin-left: calc(((100vw) - calc(1280px - 3rem)) / 2);
  }

  .swiper-container {
    overflow: visible;
  }
`;

export default ({ children }) => {
  return <OffscreenRight className="md:container">{children}</OffscreenRight>;
};
